import ChooseCurrencyForm from 'forms/ChooseCurrencyForm'

import { useTranslation } from 'next-i18next'

import styles from './RegisterByTelegramForm.module.scss'

const RegisterByTelegramForm = () => {
  const [t] = useTranslation(['shared'])

  return (
    <div className={styles.grid}>
      <h1 className={styles.h1}>{t('shared:chooseCurrency')}</h1>

      <div className={styles.form}>
        <ChooseCurrencyForm />
      </div>
    </div>
  )
}

export default RegisterByTelegramForm
